import { CheckBox } from '../../../components/CheckBox';

// mapping checkbox column id to its data type
const auditReportsColumnTypes = {
  is_active: "checkbox",
  stock_price_approved: "checkbox",
  current_price_approved: "checkbox",
  production_cost_approved: "checkbox",
  wayment_shortage_flag: "checkbox"
};

export const generateColumns = (header_details) => {
  const result = [];
  header_details.map(col => {
    let colDef = null;
    const colType = auditReportsColumnTypes[col.id];
    // Customize checkbox rendering for boolean fields here:
    if ( colType === "checkbox") {
      colDef = {
        title: col.label,
        dataIndex: col.id,
        key: col.id,
        type: "checkbox",
        render: (text, record) => (
            <CheckBox checked={Boolean(record[col.id])} disabled />
        ),
      };
    } else {
      colDef = {
        title: col.label,
        dataIndex: col.id,
        key: col.id,
      };
    }
    if (colDef) result.push(colDef);
  });
  return result;
}
